import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9x3ncwqth: FaireProductEntity = {
  token: "p_x9x3ncwqth",
  type: "product",
  name: "Mistletoe Margarita Frozen Cocktail-Just add Water + Tequila",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/6f0173c10db8fae479e17c198582794b97ae7d0fe461685ec98e13d6850e2c5c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d43503e4dda022fb737327dbdd556c933f65d236d7a5ccedeb0fef6c7d9c7b3.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Seasonal Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1.5 cups of tequila and 4.5 cups of water (total 6 cups of liquid), shake or stir and throw in the freezer. Then serve right from the bag. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party.\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and holiday design makes merchandising a breeze!\n-Perfect Christmas and hostess gifts for the entire holiday season",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:00.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
